export const STORAGE_KEY = 'cloud-watcher-active-scope';

export const readSavedScope = (storage = window.localStorage) => {
  try {
    const value = JSON.parse(storage.getItem(STORAGE_KEY) || 'null');
    return value?.organizationId && value?.projectId ? value : null;
  } catch (_) {
    return null;
  }
};

export const chooseOrganization = (organizations, savedScope) =>
  organizations.find((item) => item.id === savedScope?.organizationId) || organizations[0] || null;

export const chooseProject = (projects, savedScope, organizationId) =>
  projects.find(
    (item) => item.id === savedScope?.projectId && item.organization_id === organizationId
  ) || projects[0] || null;

